// @givmo/social — the one full-page navigation the module makes: the tab's trip to a platform's
// consent screen (`social-connect.ts`). Its own module, so a test can replace it.

export function redirectTo(url: string): void {
  window.location.assign(url);
}
